import loadable from "@loadable/component"
import { FocusScope } from "@react-aria/focus"
import { AnimatePresence } from "framer-motion"
import PropTypes from "prop-types"
import { useRef } from "react"
import ScrollLock from "react-scrolllock-with-horizontal-scroll"

import withHeader from "areas/header/hoc/with-header"
import MobileMenu from "areas/header/mobile-menu"
import Divider from "components/ui/divider"
import { retry } from "helpers/application"
import useAriaHidden from "helpers/use-aria-hidden"
import { useNavigation } from "helpers/use-navigation"

import OverLay from "../overlay"

const CountrySwitcher = loadable(() =>
  retry(() => import("./country-switcher"))
)
const CustomerCare = loadable(() => retry(() => import("./customer-care")))
const InfoNav = loadable(() => retry(() => import("./info-nav")))
const MobileNav = loadable(() => retry(() => import("./mobile-nav")))
const MobileSubmenu = loadable(() => retry(() => import("./mobile-submenu")))

const MobileMenuContent = ({ showMenu, toggleMenu }) => {
  const menuRef = useRef()
  const keyboardProps = useNavigation({
    onEscape: () => toggleMenu(showMenu),
  })

  useAriaHidden({ ref: menuRef })

  return (
    <MobileMenu id="mobile-menu" ref={menuRef} {...keyboardProps}>
      <ScrollLock isActive={showMenu}>
        <div className="side-menu-content">
          <nav className="px-12 py-10">
            <ul aria-label="Main Navigation" className="list-none" role="menu">
              <MobileNav />
              <Divider className="my-0" />
              <CountrySwitcher />
              <InfoNav />
            </ul>
          </nav>
          <Divider className="my-0" />
          <CustomerCare />
        </div>
        <MobileSubmenu />
      </ScrollLock>
    </MobileMenu>
  )
}

MobileMenuContent.propTypes = {
  showMenu: PropTypes.bool,
  toggleMenu: PropTypes.func,
}

const InternalMobileMenu = ({ showMenu, toggleMenu }) => (
  <AnimatePresence>
    {showMenu && (
      <>
        <FocusScope autoFocus contain restoreFocus>
          <MobileMenuContent showMenu={showMenu} toggleMenu={toggleMenu} />
        </FocusScope>
        <OverLay />
      </>
    )}
  </AnimatePresence>
)

InternalMobileMenu.propTypes = {
  showMenu: PropTypes.bool,
  toggleMenu: PropTypes.func,
}

export default withHeader(InternalMobileMenu)
